import { useState, useLayoutEffect } from 'react';
import { checkIsIOS } from '../utils';

/**
 * The resize event for iOS is a bit unreliable due to the new address bar introduced in iOS 15 safari:
 * When the address bar hides/shows up -> the resize event will be triggered,
 * However, occasionally, the value of window.innerHeight doesn't update immediately when resize is triggered,
 * (Confirmed issue exists across 15.0 ~ 15.2)
 */
const IOS_RECHECK_DELAY = 500;

const useWindowHeight = (delay = 250) => {
  const [height, setHeight] = useState(window.innerHeight);

  useLayoutEffect(() => {
    let timeout: ReturnType<typeof setTimeout> = null;
    let recheckTimeout: ReturnType<typeof setTimeout> = null;

    const handleResize = () => {
      if (checkIsIOS() && delay < IOS_RECHECK_DELAY) {
        clearTimeout(recheckTimeout);
        recheckTimeout = setTimeout(
          () => setHeight(window.innerHeight),
          IOS_RECHECK_DELAY,
        );
      }

      if (delay <= 0) setHeight(window.innerHeight);
      else {
        clearTimeout(timeout);
        timeout = setTimeout(() => setHeight(window.innerHeight), delay);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [delay]);

  return height;
};

export default useWindowHeight;
